<template>
  <div>

    <div class="panel panel-clinic">

      <div class="panel-heading collapsed" href="#form_contact_prospect" data-toggle="collapse">

        <div class="arrow-down"></div>

        <h2 class="panel-title">Kontaktuppgifter - prospect</h2>

      </div>

      <div id="form_contact_prospect" class="panel-collapse collapse">

        <div class="panel-body">


          <div class="form-horizontal">

              <row-text :model.sync="clinic.name_person" text="Massörens namn"></row-text>
              <row-text :model.sync="clinic.name_clinic" text="Mottagningsnamn"></row-text>

              <row-text :model.sync="clinic.group" text="Område" :asterisk="false"></row-text>

              <row-text :model.sync="clinic.address_prospect" text="Mottagningsadress – prospectfas"
                      :asterisk="false"></row-text>

              <div class="form-group oddevencol" v-bind:class="{'has-error': errors.billing_phone}">
                <label class="col-md-14 control-label">Mobilnr för kontakt & demokort</label>
                <div class="col-md-36">
                  <input type="text" v-model="clinic.billing_phone" placeholder="+46XXXXXXX" class="form-control">
                  <div class="alert alert-danger topmargin" v-show="errors.billing_phone">
                    <strong>Ogiltigt telefonnummer</strong>
                  </div>
                </div>
              </div>

              <div class="form-group oddevencol" v-bind:class="{'has-error': errors.email}">
                <label class="col-md-14 control-label">E-post för inloggning, kontakt & fakturering</label>
                <div class="col-md-36">
                  <input type="text" v-model="clinic.email" class="form-control">
                  <div class="alert alert-danger topmargin" v-show="errors.email">
                    <strong v-show="errors.email == 'duplicate'">Denna e-post används redan av en annan massör.</strong>
                    <strong v-show="errors.email == 'invalid'">Ogiltig e-post</strong>
                  </div>
                </div>
              </div>

              <row-text :model.sync="clinic.website_link" text="Hemsida" :asterisk="false"></row-text>

              <row-text :model.sync="clinic.facebook_link" text="Länk Facebook" :asterisk="false"></row-text>


              <div class="form-group oddevencol">
                <label class="col-md-14 control-label first">Tjänst</label>
                <div class="col-md-36 second">
                  <label :key="'area_'+area.id" v-for="area in product_areas" style="margin-right: 25px; font-weight:normal;">
                    <input type="checkbox" :value="area.id" v-model="clinic.product_area_ids" /> {{ area.name }}
                  </label>
                </div>
              </div>

              <row-meta
                  :clinic-id="clinic.id"
                  :row-meta="meta"
                  :extra-data="{
                      'Inget val': 1,
                      'Manuell search': 2,
                      'Automatisk search': 3,
                      'Intresseanmälan': 4,
                      'PDF/tips-mail': 5,
                      'Tips från annan massör': 6,
                  }"
                  :showComment="true"
                  type="select_prospect_source"
                  layout="selectMenu"
                  title="Prospect källa">
              </row-meta>

              <row-meta
                  :clinic-id="clinic.id"
                  :row-meta="meta"
                  :extra-data="admins"
                  :showDate="true"
                  type="select_prospect_manager"
                  layout="selectMenuArray"
                  title="Prospect ansvarig person">
              </row-meta>

          </div>

          <h3>Bilder från prospect</h3>

          <p v-if="clinic.previewProspect && clinic.previewProspect.length === 0">Inga bilder uppladdade</p>

          <div v-if="clinic.previewProspect && clinic.previewProspect.length > 0" style="display: flex; flex-wrap: wrap; gap: 10px;">
            <div v-for="image in clinic.previewProspect" :key="image.id" style="text-align: center;">
              <a :href="'/storage/clinic-presentation/' + image.name + '.jpg'" target="_blank">
                <div style="height: 200px; margin-right: 20px; margin-bottom: 20px;">
                <img
                  :src="'/storage/clinic-presentation/' + image.name + '.jpg'"
                  style="height: 100%;">
                </div>
              </a>
              <button
                class="btn btn-xs btn-success"
                @click="importProspectImage(image.id)"
                :disabled="importingImageId !== null"
              >{{ importingImageId === image.id ? 'Importerar...' : 'Importera som lokalbild' }}</button>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import mixin from './mixin'

export default {

    mixins: [mixin],

    props: {
        product_areas: {
            required: true
        }
    },

    data () {
        return {
            importingImageId: null
        }
    },

    computed: {

      admins () {
          const admins = []

          admins.push({

              value: null,
              text: 'Välj'

          })

          _.forEach(_.filter(this.users, ['type', 'admin']), function (admin) {
              admins.push({

                  value: admin.id,
                  text: admin.name

              })
          })

          return admins
      }
    },

    methods: {
        importProspectImage (imageId) {
            if (this.importingImageId) {
                return
            }

            this.importingImageId = imageId

            axios.post('/clinics/' + this.clinic.id + '/images/' + imageId + '/import')
                .then(response => {
                    bus.$emit('notify', 'Bilden importerades som lokalbild.')
                    bus.$emit('refresh-data')
                })
                .catch(error => {
                    const message = error.response && error.response.data && error.response.data.message
                    alert(message || 'Importen misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.importingImageId = null
                })
        }
    }

}
</script>
